import gql from 'graphql-tag';

export default gql`
  fragment TasksByWeek on myTasks {
    tasksByWeek {
      weekNumber
      tasks {
        id
        objectTags {
          taggable_id
          taggable_type
          tag {
            id
            tag
          }
        }
        name
        dueDays
        calendarDueDays
        mappedType
        props
        project_id
        earlyStartDate
        earlyFinishDate
        color {
          color
          help
        }
        issues
        lateDays
        successorTasks {
          id
          name
          dueDays
          props
          project_id
          responsibleUser {
            id
            first_name
            last_name
            display_name
            avatar {
              id
              path
            }
          }
        }
      }
    }
    waitlist {
      id
      first_name
      last_name
      display_name
      avatar {
        id
        path
      }
    }
  } 
`



// WEBPACK FOOTER //
// ./src/fragments/myTasks.js